import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { featureSelectors, searchSelectors } from '@lifesize/nucleus';
import { filterSearchedContactsInCall } from 'utils/contact-utils';
import actions from 'actions/AddParticipantDrawer';
import { ADD_PARTICIPANT_FORM } from 'constants/AddParticipantDrawer';
import { checkForCustomEntry } from 'utils/call-utils';
import AddParticipantSearch from 'components/AddParticipantDrawer/Search/AddParticipantSearch';
import _get from 'lodash/get';
import { FLAG_PRESENTATION_RESTRICTION } from 'constants/FeatureFlags';

const searchResults = [];

const mapDispatchToProps = dispatch => ({
  handleSelectContact: (contact) => {
    dispatch(actions.selectContactForCall(contact));
    dispatch(reset(ADD_PARTICIPANT_FORM));
    dispatch(actions.setFormFocus(false));
  },
  clearSelectedCall: () => {
    dispatch(reset(ADD_PARTICIPANT_FORM));
    dispatch(actions.clearAddList());
    dispatch(actions.setFormFocus(true));
  },
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    if (!selectedContact) return;
    dispatch(actions.selectContactForCall(selectedContact));
    dispatch(reset(ADD_PARTICIPANT_FORM));
    dispatch(actions.setFormFocus(false));
  }
});

function mapStateToProps(state, ownProps) {
  const { participants } = ownProps;
  const searchString = _get(state, 'app.form.participantSearch.values.addParticipantSearchBar') || '';
  const isFocused = _get(state, 'app.addParticipantDrawer.isFocused');
  const searchContacts = filterSearchedContactsInCall(searchSelectors.searchUsersAndRoomSystemsOutsideCall(state), participants);

  const selectedContact = _get(state, 'app.addParticipantDrawer.contact');

  const isSearching = _get(state, 'nucleus.directory.isSearching');
  const showCustomDial = checkForCustomEntry(searchString);
  let searchLength;
  if (searchContacts.length === 0 && searchString) {
    searchLength = 1;
  } else if (!searchString) {
    searchLength = 0;
  } else {
    searchLength = searchContacts.length;
  }

  if (searchResults.length !== searchLength) {
    searchResults.length = searchLength;
  }

  return {
    searchContacts,
    searchString,
    isFocused,
    presentationRestrictionFlagEnabled: featureSelectors.getFeatureFlag(state)(FLAG_PRESENTATION_RESTRICTION),
    selectedContact,
    searchResults,
    showCustomDial,
    isSearching
  };
}

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AddParticipantSearch);

const FunctionalComponent = (props) => {
  const participants = hooks.useParticipants();

  return (
    <ConnectedComponent
      {...props}
      participants={participants}
    />
  );
}

export {
  ConnectedComponent as AddParticipantSearchContainer
}

export default FunctionalComponent;
